import { BannerTableItemType, IBannerItem } from 'entities/banner/types';

export const useDefaultBannersTableValue = (banners: IBannerItem[]): BannerTableItemType[] =>
  banners.map(({ contents: [{ title = '', description = '' }], ...rest }) => ({
    title,
    description,
    ...rest,
  }));
